import React from "react";

const SearchChannelContext = React.createContext({searchChannel:null, setSearchChannel:()=>{}});
export default SearchChannelContext;

